import React from 'react';
import './HeaderDash.css';
import ButonScreen from '../ButonScreen/ButonScreen';
import InputSearch from '../InputSearch/InputSearch';
import InfoUser from '../InfoUser/InfoUser';
import { Link as Anchor } from "react-router-dom";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faHome, faCrown } from '@fortawesome/free-solid-svg-icons';
import { usePlan } from '../../PlanContext';
import { ruta } from '../../paths';

export default function HeaderDash() {
    const { plan, isPlus, loading } = usePlan();

    return (
        <div className={`HeaderDashContain`}>
            <InputSearch />

            <div className='deFlexHeader'>
                {!loading && (
                    <div
                        title={`Plan actual: ${plan.toUpperCase()}`}
                        style={{
                            display: 'inline-flex',
                            alignItems: 'center',
                            gap: '6px',
                            padding: '6px 12px',
                            borderRadius: '20px',
                            background: isPlus ? 'linear-gradient(135deg, #FFD700, #FFA500)' : '#e9ecef',
                            color: isPlus ? '#fff' : '#495057',
                            fontWeight: 700,
                            fontSize: '12px',
                            letterSpacing: '0.5px',
                            boxShadow: isPlus ? '0 2px 6px rgba(255,165,0,0.4)' : 'none',
                        }}
                    >
                        <FontAwesomeIcon icon={faCrown} />
                        {plan.toUpperCase()}
                    </div>
                )}
                <ButonScreen />
                <Anchor to={ruta('/')} className='link'>
                    <FontAwesomeIcon icon={faHome} /> Inicio
                </Anchor>
                <InfoUser />
            </div>


        </div>
    );
}
